// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"27":"f1e13fef","138":"0ebdf4f0","195":"caa3b286","212":"2a532ae5","220":"41dd0cff","456":"4dd3a9e4","481":"e0cbafa8","662":"bc71576d","757":"2891cd0f","808":"37ddce75","829":"5af5b23b","848":"c4effa3a","871":"6140cc98"}[chunkId] + ".js";
};